import React from "react"
import { Table } from "antd"
import { withRouter } from "react-router-dom"
import { view } from "react-easy-state"

import globalStore from "store/index"

class DoubtList extends React.Component {
  componentDidMount() {
    const doubts = globalStore.ui.teachers.doubts.index

    console.log("doubts", doubts)
  }

  renderTable = () => {
    const { doubts } = globalStore.ui.teachers.doubts.index

    const tableData = doubts
      ? doubts.map((d) => {
          return {
            id: d.id,
            description: d.description,
            subject: d.subject && d.subject.name,
            chapter: d.chapter && d.chapter.name,
            files: d.attached_files && d.attached_files.length,
          }
        })
      : []

    const columns = [
      {
        title: "Description",
        dataIndex: "description",
        key: "description",
      },
      {
        title: "Subject",
        dataIndex: "subject",
        key: "subject",
      },
      {
        title: "Chapter",
        dataIndex: "chapter",
        key: "chapter",
      },
      {
        title: "Files",
        dataIndex: "files",
        key: "files",
        render: (v) => {
          if (v > 0) {
            return `${v} ${v > 1 ? "files" : "file"} attached`
          }
          return "No file attached"
        },
      },
    ]

    return (
      <Table
        bordered
        dataSource={tableData}
        columns={columns}
        onRow={(record, rowIndex) => {
          return {
            onClick: (event) => {
              this.props.history.push(`/teachers/doubts/${record.id}`)
            },
          }
        }}
      />
    )
  }

  render() {
    return (
      <div>
        <h1>All Doubts</h1>
        {this.renderTable()}
      </div>
    )
  }
}

export default withRouter(view(DoubtList))
